import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import type { MenuEntry } from '@/types/navigation'
import { useNavigation } from './useNavigation'

type ListOptionVariant = 'neutral' | 'loyalty'

export const useSideNav = () => {
  const { items, activeRoute, isActive } = useNavigation()
  const { t } = useI18n()
  const openGroups = ref(new Set<string>())

  const isGroupOpen = (label: string) => openGroups.value.has(label)

  watch(
    activeRoute,
    (routeName) => {
      if (!routeName) return
      for (const entry of items.value) {
        // If is MenuSection
        if ('children' in entry && entry.children.some((child) => child.routeName === routeName)) {
          openGroups.value.add(entry.i18nLabel)
        }
      }
    },
    { immediate: true }
  )

  const onDetailToggle = (event: Event, label: string) => {
    const isNowOpen = (event.target as HTMLDetailsElement).open
    if (isNowOpen) {
      openGroups.value.add(label)
    } else {
      openGroups.value.delete(label)
    }
  }

  const menuEntriesToListOptions = (entries: MenuEntry[]) =>
    entries.map((entry, index) => ({
      label: t(entry.i18nLabel),
      value: index,
      selected: isActive(entry),
      prependIcon: entry.icon?.svg,
      variant: entry.externalHighlight ? 'loyalty' : ('neutral' as ListOptionVariant)
    }))

  return {
    openGroups,
    isGroupOpen,
    onDetailToggle,
    menuEntriesToListOptions
  }
}
